import { AuthGuard } from '../auth-guard.service';
import { billingRoutes } from '../features/billing/billing-routing.module';
import { bulktaxReportRoutes } from '../features/bulk-tax-report/bulk-tax-report-routing.module';
import { CustomerRequestComponent } from '../features/customer-request/customer-request.component';
import { customerRoutes } from '../features/customer/customer-routing.module';
import { dashboardRoutes } from '../features/dashboard/dashboard-routing.module';
import { documentRequestRoutes } from '../features/document-request/document-request-routing.module';
import { documentRoutes } from '../features/document/document-routing.module';
import { emailDashboardRoutes } from '../features/email-dashboard/email-dashboard-routing.module';
import { historyLogRoutes } from '../features/history-log/history-log-routing.module';
import { importDataRoutes } from '../features/import-data/import-data-routing.module';
import { profileRoutes } from '../features/profile/profile-routing.module';
import { rdSendReportRoutes } from '../features/rd-send-report/rd-send-report-routing.module';
import { reportRoutes } from '../features/report/report-routing.module';
import { saleTaxRoutes } from '../features/saletax/saletax-routing.module';
import { searchRoutes } from '../features/search/search-routing.module';
import { sellerRoutes } from '../features/seller/seller-routing.module';
import { productRoutes } from "../features/product/product-routing.module";
import { settingsRoutes } from '../features/settings/settings-routing.module';
import { submitToRdRoutes } from '../features/submit-to-rd/submit-to-rd-routing.module';
import { taxB2PRoutes } from '../features/tax-b2p/tax-b2p-routing.module';
import { taxReportRoutes } from '../features/tax-report/tax-report-routing.module';
import { zipFileRoutes } from '../features/zip-file/zip-file-routing.module';
import { LoginComponent } from '../login/login.component';
import { ValidateOtpComponent } from '../validate-otp/validate-otp.component';
import { MainComponent } from './main.component';
import { AbbDashboardRoutes } from '../features/abb-dashboard/abb-dashboard-routing.module';
import { DocumentApprovalPreviewComponent } from '../features/document-approval/document-approval-preview/document-approval-preview.component';
import { departmentRoutes } from '../features/department/department-routing.module';
export var mainRoutes = [
    // for role IT, default page is /dashboard-it
    // for role Accountant, default page is /taxReport
    // more information is in constructor of file 'dashboard-list.component.ts'
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    { path: 'validate-otp', component: ValidateOtpComponent },
    { path: 'validate-otp/:msg', component: ValidateOtpComponent },
    { path: 'login/:msg', component: LoginComponent },
    { path: 'login', component: LoginComponent },
    { path: 'customer-request', component: CustomerRequestComponent },
    {
        path: 'document-approval/preview',
        component: DocumentApprovalPreviewComponent,
    },
    {
        path: '',
        component: MainComponent,
        children: documentRoutes.concat(reportRoutes, searchRoutes, dashboardRoutes, billingRoutes, saleTaxRoutes, profileRoutes, taxReportRoutes, zipFileRoutes, submitToRdRoutes, settingsRoutes, taxB2PRoutes, bulktaxReportRoutes, emailDashboardRoutes, importDataRoutes, customerRoutes, sellerRoutes, productRoutes, rdSendReportRoutes, historyLogRoutes, documentRequestRoutes, AbbDashboardRoutes, departmentRoutes),
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard]
    }
];
var MainRoutingModule = (function () {
    function MainRoutingModule() {
    }
    return MainRoutingModule;
}());
export { MainRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/main/main-routing.module.ts.pre-build-optimizer.js